/* Built In Imports */
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Image, Link } from '@chakra-ui/react';
import forEach from 'lodash/forEach';
import { useCookies } from 'react-cookie';
import { useMediaQuery } from 'react-responsive';
import { Link as HashLink } from 'react-scroll';

/* Internal Imports */
/* Components */
import PatientNoteModal from '@components/Modal/PatientNoteModal';
// import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import { isOpenInNewTab, refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
/* Mixpanel for SEO*/
import { mixPanel } from '@utils/Mixpanel';

/* Services */

/**
 * Returns the Simple Button.
 *
 * @param style.style
 * @param {object} style - Style for button.
 * @param {string} bType - Button Type.
 * @param {string} region - Current User country?.
 * @param {string} language - Current User Language.
 * @param style.bType
 * @param style.region
 * @param style.lang
 * @param style.clickHandler
 * @param style.padding
 * @param style.textAlign
 * @param style.width
 * @param style.mb
 * @param style.mt
 * @param style.fontstyle
 * @param style.fontbold
 * @param style.extraDomains
 * @param style.disabled
 * @param style.pageName
 * @param style.height
 * @returns {ReactElement} SimpleButton component.
 */
export default function SimpleButton({
  style,
  bType,
  region,
  lang,
  clickHandler,
  height,
  padding,
  textAlign,
  width,
  mb,
  mt,
  mx,
  fontstyle,
  fontbold,
  pageName,
  pageConfig,
  disabled = false,
  icon,
  disableButton = false,
  scrollId,
  hashScroll,
  targetwindow,
  lineHeight,
  cta,
  program_name,
  mixpanelenabled,
  modelApiKey,
  eventid,
  buttonType,
  useBlankStringURLOnLink,
  ...props
}) {
  const pName = pageConfig?.pageName;
  const router = useRouter();
  const [currentUrl, setCurrentUrl] = useState('');
  const cookieParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
  ];
  const [cookies, setCookie] = useCookies(cookieParams);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [shouldHide, setShouldHide] = useState(false);
  let url = router.asPath;
  if(url.indexOf('/volunteer/sadhanapada') > -1)
  {
    eventid = "sadhanapada_cta_click";
    mixpanelenabled = "true";
    cta = "top cta";
    program_name = "Sadhanapada 2026";
  }else if(url.indexOf('/events/special-events/ishanga7') > -1)
  {
    mixpanelenabled = "true";
    cta = modelApiKey === "top_banner_event" || modelApiKey === "top_banner_v2" ? "top" : "bottom";
    eventid = "ishanga_7%_cta_click"; 
    program_name = "Ishanga 7%";
  }
  else if(url.indexOf('/yoga-meditation/free-yoga-day') > -1)
  {
    mixpanelenabled = "true";
    cta = modelApiKey === "top_banner_event" || modelApiKey === "top_banner_v2" ? "top" : "bottom";
    eventid = "free_yoga_day_cta_click"; 
    program_name = "RSVP";
  }
  else if (url.indexOf('/yoga-meditation/yoga-teacher-training/yoga-veera') > -1){
    mixpanelenabled = "true";
    cta = modelApiKey === "top_banner_event" || modelApiKey === "top_banner_v2" ? "top" : "bottom";
    eventid = "yoga_meditation_join_training_cta_click";
    program_name = "Become a Yoga Veera";
  }
  else if (url.indexOf('/yoga-meditation/yoga-program-for-beginners/uyirnokkam') > -1){
    mixpanelenabled = "true";
    cta = buttonType? buttonType : modelApiKey === "top_banner_event" || modelApiKey === "top_banner_v2" ? "top" : "bottom";
    eventid = "yoga_meditation_register_free_cta_click";
    program_name = "Uyirnokkam";
  }
  else if (url.indexOf('/yoga-meditation') > -1){
    mixpanelenabled = "true";
    console.log("modelApiKey", modelApiKey);
    cta = modelApiKey === "top_banner_event" || modelApiKey === "top_banner_v2" ? "top" : "bottom";
  }

  const MixpanelEvent = (btnText='', cta='', program_name='', eventid='', linkUrl='', url) => {
    if(btnText){
        const Mixpanel = mixPanel(window?.location.pathname);
        if(linkUrl.includes("#freeyogaregistration"))
        {
            Mixpanel.track("free_yoga_day_form_impression", {
              page_name: document.title,
            });
        }
        if(eventid == "ishanga_7%_cta_click"){
            Mixpanel.track( eventid? eventid:"", {
              cta: cta ? cta : "",
              donation_name: program_name ? program_name : "",
              element: btnText,
            });
        }else{
          if(eventid == "free_yoga_day_cta_click"){
          Mixpanel.track( eventid? eventid:"", {
              cta: cta ? cta : "",
              element: btnText,
          });
          window.dataLayer = window.dataLayer || [];
          window?.dataLayer?.push({
            event:'Interested_Users',
            program_name:'Free Yoga Day',
            Button_Location:'<Top_CTA>'
          })

          }else if(eventid == "pbk_register_now_clicked")
          {
            Mixpanel.track( eventid? eventid:"", {
              cta: cta ? cta : "",
              element: btnText,
             });
          }
          else
          {
            if(url.indexOf('/yoga-meditation') > -1){
              if(btnText.toLowerCase() === "register now"){
                eventid = 'yoga_meditation_register_now_cta_click';
              }
              if(btnText.toLowerCase() === "join here"){
                eventid = 'yoga_meditation_join_here_cta_click';
              }
              let program_type = "";
              eventid == "yoga_meditation_interested_cta_click" ? program_type = "Advanced Programs" : 
              eventid == "yoga_meditation_register_free_cta_click" ? program_type = "Beginners programs" :
              eventid == "yoga_meditation_join_training_cta_click" ? program_type = "Yoga Teacher Training" :
              eventid == "yoga_meditation_join_here_cta_click" ? program_type = "Additional Programs" : "";
              if(eventid == "yoga_meditation_register_now_cta_click"){
                const pathSegments = window.location.pathname.split('/').filter(Boolean);
                const cleanValue = (value) => value?.replace(/-/g, ' ') || null;
                //program_type = cleanValue(pathSegments[3]);
                program_name = cleanValue(pathSegments[pathSegments.length - 1]);
              }
  
              if(eventid == "yoga_meditation_register_free_cta_click"){
                Mixpanel.track(eventid? eventid:"", {
                  program_name:program_name,
                  //program_type: program_type,
                  page_name:document.title,
                  program_source:router?.query?.source ? router?.query?.source : "direct",
                  cta: cta ? cta : "",
                  element: btnText,
                 });
              }else{
              Mixpanel.track(eventid? eventid:"", {
                program_name:document.title,
                //program_type: program_type,
                page_name:document.title,
                //master_program:router?.query?.sourcem ? router?.query?.sourcem : "",
                program_source:router?.query?.source ? router?.query?.source : "direct",
                cta: cta ? cta : "",
                element: btnText,
               });
              }
            }
            else
            {
              Mixpanel.track(eventid? eventid:"", {
                cta: cta ? cta : "",
                program_name: program_name ? program_name : "",
                element: btnText,
              });
           }
          }
       }
    }
  }

  const getNormalButton = style => {
    return (
      <Link
        className="orange-button"
        mb={mb || '30px'}
        display={icon ? 'flex' : 'block'}
        justifyContent="center"
        alignItems="center"
        fontWeight={fontbold || '500'}
        fontFamily={fontstyle || 'FedraSansStd-medium'}
        fontSize={'18px'}
        bgColor={disabled ? 'rgb(207 69 32 / 41%)' : '#cf4520'}
        h={lineHeight || 'auto'}
        lineHeight={lineHeight}
        minH="50px"
        cursor={disabled ? 'not-allowed' : 'pointer'}
        textAlign={textAlign || 'center'}
        padding={padding || '14px 29px'}
        borderRadius="5px"
        color="#faf7f0"
        textDecoration="none"
        width={width || 'auto'}
        _hover={{
          bg: disabled ? 'rgb(207 69 32 / 41%)' : '#000054',
        }}
        //onClick={url.lastIndexOf('/sadhanapada') ? MixpanelEvent(style?.buttonText): clickHandler}
        onClick={() =>
          mixpanelenabled == 'true'
            ? MixpanelEvent(
                style?.buttonText,
                cta,
                program_name,
                eventid,
                style?.linkUrl,
                url
              )
            : clickHandler
        }
        
        {...props}
      >
        {icon && (
          // <LazyLoadImageComponent
          //   w="32px"
          //   h="100%"
          //   mr="10px"
          //   mt="-5px"
          //   src={icon}
          // />
          <Image w="32px" h="100%" mr="10px" mt="-5px" src={icon} alt={icon} />
        )}
        {style?.buttonText}
      </Link>
    );
  };

  useEffect(() => {
    if (pName === 'freeyogaday' && disableButton === true) {
      setShouldHide(true);
    } else if (pName === 'freeyogaday' && isMobile === true) {
      setShouldHide(isMobile);
    }

    if (!router.isReady) return;
    setCurrentUrl(refineUrlDomain(style?.linkUrl, region, lang));
    // setTimeout(function () {
    forEach(cookieParams, function (cookie) {
      if (router.query[cookie]) {
        setCookie(cookie, router.query[cookie], {
          path: '/',
          maxAge: 3600 * 24, // Expires after 1year
          sameSite: true,
          domain: config.COOKIE_DOMAIN,
          secure: true,
        });
      }
    });
    // }, 0);
  }, [router.isReady, style?.linkUrl, isMobile, pageName]);
  const RenderButton = ({ style }) => {
    const buttonStyle = {
      Orange:
        currentUrl.startsWith('ieo-enroll-section') &&
        !currentUrl.startsWith('#freeyogaregistration') ? (
          <HashLink
            to={currentUrl}
            spy="true"
            //smooth={true}
            offset={0}
            //duration={1200}
            // delay={100}
          >
            <Box
              className="orange-button"
              position="relative"
              zIndex="99"
              mb={mb || '30px'}
              display={icon ? 'flex' : 'block'}
              justifyContent="center"
              alignItems="center"
              fontWeight={fontbold || '500'}
              fontFamily={fontstyle || 'FedraSansStd-medium'}
              fontSize={'18px'}
              bgColor={disabled ? 'rgb(207 69 32 / 41%)' : '#cf4520'}
              h={'auto'}
              minH="50px"
              cursor={disabled ? 'not-allowed' : 'pointer'}
              textAlign={textAlign || 'center'}
              padding={padding || '14px 29px'}
              borderRadius="5px"
              color="#faf7f0"
              textDecoration="none"
              width={width || 'auto'}
              _hover={{
                bg: disabled ? 'rgb(207 69 32 / 41%)' : '#000054',
              }}
              onClick={clickHandler}
              target={
                style?.openInNewTab == true
                  ? '_blank'
                  : isOpenInNewTab(currentUrl) || targetwindow
                  ? '_blank'
                  : ''
              }
              {...props}
            >
              {icon && (
                // <LazyLoadImageComponent
                //   w="32px"
                //   h="100%"
                //   mr="10px"
                //   mt="-5px"
                //   src={icon}
                // />
                <Image
                  w="32px"
                  h="100%"
                  mr="10px"
                  mt="-5px"
                  src={icon}
                  alt={icon}
                />
              )}
              {style?.buttonText}
            </Box>
          </HashLink>
        ) :  useBlankStringURLOnLink ? (
          getNormalButton(style)
        ) : (
          <NextLink href={disabled ? '#' : currentUrl} passHref legacyBehavior>
            {getNormalButton(style)}
          </NextLink>
        ),

      'White with Orange outline': (
        <NextLink href={disabled ? '#' : currentUrl} passHref legacyBehavior>
          <Link
            display="inline-block"
            mb={mb || '20px'}
            fontFamily="FedraSansStd-medium"
            borderRadius="5px"
            bgColor="transparent"
            border="solid 1px #cf4520"
            color="#cf4520"
            fontSize="18px"
            padding="14px 29px"
            _hover={{
              textDecoration: 'none',
              bgColor: '#cf4520',
              color: 'white',
            }}
            textAlign={textAlign || 'left'}
            width={'auto'}
            h="auto"
            minH="50px"
            // minW="200px"
            m="0 auto"
            //onClick={clickHandler}
            onClick={() => mixpanelenabled == "true" ? MixpanelEvent(style?.buttonText, cta, program_name, eventid, style?.linkUrl, url): clickHandler}
            target={
              style?.openInNewTab == true
                ? '_blank'
                : isOpenInNewTab(currentUrl)
                ? '_blank'
                : ''
            }
            {...props}
          >
            {style?.buttonText}
          </Link>
        </NextLink>
      ),
      'Program Finder Button': (
        <NextLink href={disabled ? '#' : currentUrl} passHref legacyBehavior>
          <Link
            fontFamily="FedraSansStd-medium"
            borderRadius="21.4px"
            border="none"
            padding="10px 10px"
            fontWeight="350"
            lineHeight="17.5px"
            fontSize="14px"
            _hover={{
              textDecoration: 'none',
              bgColor: '#DCD5C3',
              color: '#676055',
            }}
            textAlign={textAlign || 'left'}
            width={'auto'}
            h="auto"
            minH="45px"
            // minW="200px"
            m="0 auto"
            onClick={clickHandler}
            target={
              style?.openInNewTab == true
                ? '_blank'
                : isOpenInNewTab(currentUrl)
                ? '_blank'
                : ''
            }
            {...props}
          >
            {style?.buttonText}
          </Link>
        </NextLink>
      ),
      Blue: (
        <NextLink href={disabled ? '#' : currentUrl} passHref legacyBehavior>
          <Link
            width="auto"
            minW="200px"
            height="48px"
            borderRadius="4px"
            fontFamily="'FedraSansStd-book', sans-serif"
            fontSize="16px"
            color="#ffffff"
            lineHeight="48px"
            textAlign="center"
            marginTop="30px"
            textDecoration="none"
            colorScheme={'#293B7D'}
            background="#293B7D"
            _hover={{ bg: '#293B7D', border: 'none' }}
            _active={{ bg: '#293B7D', border: 'none' }}
            _focus={{ bg: '#293B7D', border: 'none' }}
            onClick={clickHandler}
            target={
              style?.openInNewTab == true
                ? '_blank'
                : isOpenInNewTab(currentUrl)
                ? '_blank'
                : ''
            }
          >
            {style?.buttonText}
          </Link>
        </NextLink>
      ),
      Yellow: (
        <NextLink href={disabled ? '#' : currentUrl} passHref legacyBehavior>
          <Link
            width="100%"
            // minW="200px"
            // maxW="188px"
            height="46px"
            fontFamily="'FedraSansStd-medium', sans-serif"
            fontSize="16px"
            lineHeight="46px"
            background="#EAB646"
            borderRadius="5px"
            color="#28231E"
            fontWeight={'300'}
            textAlign="center"
            marginTop="20px"
            p={5}
            pt="0"
            onClick={clickHandler}
            target={
              style?.openInNewTab == true
                ? '_blank'
                : isOpenInNewTab(currentUrl)
                ? '_blank'
                : ''
            }
            _hover={{
              background: '#F5E3B5',
              border: '1px solid #F5E3B5',
              color: '#000000',
            }}
            _focus={{
              background: '#F5E3B5',
              border: '1px solid #F5E3B5',
              color: '#000000',
            }}
            _active={{
              background: '#F5E3B5',
              border: '1px solid #F5E3B5',
              color: '#000000',
            }}
            _visited={{
              background: '#F5E3B5',
              border: '1px solid #F5E3B5',
              color: '#000000',
            }}
            {...props}
          >
            {style?.buttonText}
          </Link>
        </NextLink>
      ),
      'Otp-Yellow': (
        <NextLink href={disabled ? '#' : currentUrl} passHref legacyBehavior>
          <Link
            width="100%"
            // minW="200px"
            // maxW="188px"
            height={lineHeight || "46px"}
            fontFamily="'FedraSansStd-medium', sans-serif"
            fontSize="18px"
            lineHeight={lineHeight || "46px"}
            background="#FFAE27"
            borderRadius="5px"
            color="#28231E"
            fontWeight={'300'}
            textAlign="center"
            marginTop="20px"
            p={5}
            pt="0"
            onClick={clickHandler}
            target={
              style?.openInNewTab == true
                ? '_blank'
                : isOpenInNewTab(currentUrl)
                ? '_blank'
                : ''
            }
            _hover={{
              background: '#EF9D16',
              border: '1px solid #EF9D16',
              color: '#28231E',
            }}
            _focus={{
              background: '#EF9D16',
              border: '1px solid #EF9D16',
              color: '#28231E',
            }}
            _active={{
              background: '#EF9D16',
              border: '1px solid #EF9D16',
              color: '#28231E',
            }}
            _visited={{
              background: '#EF9D16',
              border: '1px solid #EF9D16',
              color: '#28231E',
            }}
            {...props}
          >
            {style?.buttonText}
          </Link>
        </NextLink>
      ),
      'Surya-Shakti-Yellow': (
        <NextLink href={disabled ? '#' : currentUrl} passHref legacyBehavior>
          <Link
            width="100%"
            // minW="200px"
            // maxW="188px"
            height={lineHeight || "46px"}
            fontFamily="MuktaMalar"
            fontSize="18px"
            lineHeight={lineHeight || "46px"}
            background="#F5A147"
            borderRadius="5px"
            color="#28231E"
            fontWeight={'700'}
            textAlign="center"
            marginTop="20px"
            p={5}
            pt="0"
            onClick={clickHandler}
            target={
              style?.openInNewTab == true
                ? '_blank'
                : isOpenInNewTab(currentUrl)
                ? '_blank'
                : ''
            }
            // _hover={{
            //   background: '#EF9D16',
            //   border: '1px solid #EF9D16',
            //   color: '#28231E',
            // }}
            // _focus={{
            //   background: '#EF9D16',
            //   border: '1px solid #EF9D16',
            //   color: '#28231E',
            // }}
            // _active={{
            //   background: '#EF9D16',
            //   border: '1px solid #EF9D16',
            //   color: '#28231E',
            // }}
            // _visited={{
            //   background: '#EF9D16',
            //   border: '1px solid #EF9D16',
            //   color: '#28231E',
            // }}
            {...props}
          >
            {style?.buttonText}
          </Link>
        </NextLink>
      ),
      'Death-Book': (
        <NextLink href={disabled ? '#' : currentUrl} passHref legacyBehavior>
          <Box onClick={clickHandler} cursor={'pointer'} position={'relative'}
            width={width || "100%"}
            // minW="200px"
            // maxW="188px"
            height={lineHeight || "80px"}
            fontFamily="FedraSansStd-medium"
            fontSize={{base:'18px', md:"26px"}}
            lineHeight={lineHeight || "80px"}
            background="#007088"
            borderRadius="10px"
            color="#fff"
            fontWeight={'500'}
            textAlign="center"
            marginTop="20px"
            // p={5}
            pt="0"
            _hover={{
              background: '#0A5A73',
              border: '1px solid #0A5A73',
              color: '#FFFFFF'
            }}
            {...props}>
            <Link
              marginLeft={'-2rem'}
              target={
                style?.openInNewTab == true
                  ? '_blank'
                  : isOpenInNewTab(currentUrl)
                    ? '_blank'
                    : ''
              }
              _hover={{
                textDecoration: 'none'
              }}
            // _focus={{
            //   background: '#EF9D16',
            //   border: '1px solid #EF9D16',
            //   color: '#28231E',
            // }}
            // _active={{
            //   background: '#EF9D16',
            //   border: '1px solid #EF9D16',
            //   color: '#28231E',
            // }}
            // _visited={{
            //   background: '#EF9D16',
            //   border: '1px solid #EF9D16',
            //   color: '#28231E',
            // }}
            >
              {style?.buttonText}
            </Link>
            <Box position={'absolute'} right={{base:'1rem', lg:'1.8rem'}} top={{base:'31%', lg:'37%'}}>
              <svg width="24" height="24" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.0005 1L17.0005 6.99998M17.0005 6.99998L11.0005 13M17.0005 6.99998L1.00049 6.99998" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </Box>
          </Box>
        </NextLink>
      ),
      'yoga-sandhya-yellow': (
        <NextLink href={disabled ? '#' : currentUrl} passHref legacyBehavior>
          <Link
            // minW="200px"
            // maxW="188px"
            width="auto"
            minW={
              width
                ? width
                : pName === 'hytt'
                ? '200px'
                : { base: '188px', md: '188px' }
            }
            // height={height || '46px'}
            height={height ? height : pName === 'hytt' ? '58px' : '46px'}
            fontStyle="normal"
            fontWeight="500"
            fontFamily="'FedraSansStd-medium', sans-serif"
            fontSize={pName === 'hytt' ? '20px' : '16px'}
            lineHeight="46px"
            background={style?.linkUrl != '' ? '#FFAE27' : '#909090'}
            borderRadius="5px"
            color={
              pName === 'hytt'
                ? '#262626'
                : style?.linkUrl != ''
                ? '#000'
                : '#000'
            }
            // fontWeight={'300'}
            textAlign="center"
            marginTop="20px"
            p={padding || 5}
            // pt={padding ? 'auto' : '0'}
            pt={pName === 'hytt' ? '1' : padding ? 'auto' : '0'}
            cursor={style?.linkUrl == '' ? 'not-allowed' : 'pointer'}
            _hover={{
              textDecoration: 'none',
              bgColor: style?.linkUrl != '' ? '#cf4520' : '#909090',
              color: style?.linkUrl != '' ? '#fff' : '#000',
            }}
            _focus={{
              background: '#cf4520',
              border: '1px solid #F5E3B5',
              color: '#000000',
            }}
            _active={{
              background: '#cf4520',
              border: '1px solid #F5E3B5',
              color: '#000000',
            }}
            onClick={() => mixpanelenabled == "true" ? MixpanelEvent(style?.buttonText, cta, program_name, eventid, style?.linkUrl, url): clickHandler}
            //onClick={clickHandler}
            target={
              style?.openInNewTab == true
                ? '_blank'
                : isOpenInNewTab(currentUrl)
                ? '_blank'
                : ''
            }
            {...props}
          >
            {style?.buttonText}
          </Link>
        </NextLink>
      ),
    };
    return buttonStyle[style?.buttonStyle] || null;
  };

  return (
    <>
      {shouldHide ||
      (pName === 'freeyogaday' && disableButton === true) ? null : (
        <Box
          boxSizing="borderBox"
          display={bType ? 'flex' : 'flex'}
          alignItems="center"
          as={'button'}
          color="#faf7f0"
          width={'auto'}
          h={height || 'auto'}
          minH={height || '50px'}
          borderRadius="5px"
          fontSize={'18px'}
          textAlign="center"
          justifyContent={bType ? 'center' : 'center'}
          cursor="default"
          mb={mb || '30px'}
          mt={mt ? mt : '12px'}
          mx={mx}
          className={disableButton}
        >
          {!bType && currentUrl ? <RenderButton style={style} /> : null}
          {bType && PatientNoteModal(style, currentUrl)}
        </Box>
      )}
    </>
  );
}
